import React, { memo } from 'react';
import './Styles.css';
import AddressSearch from '../CommonFields/AddressSearch';
import PostalFields from '../CommonFields/PostalFields';
import CareOfFields from '../CommonFields/CareOfFields';
import AddressCountrySelector from '../CommonFields/AddressCountrySelector';
import { PresentationMode } from '../../../../Enums/PresentationMode';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import TextInput from '../../../ids/InputElements/TextInput';

const UnstructuredAddress = ({ getCommonFields, modalMode, addressState, setAddressState, countryList }) => {
  return (
    <>
      {modalMode === PresentationMode.Add && (
        <AddressSearch addressState={addressState} setAddressState={setAddressState} />
      )}

      <CareOfFields modalMode={modalMode} addressState={addressState} setAddressState={setAddressState} />

      <TextInput
        label={formatMessage(Messages.addressInfo_addressLine, {
          lineNumber: 1,
        })}
        {...getCommonFields('addressLine1', true)}
        cssClasses="formatSwitcher-unstructured-input"
      />

      <TextInput
        label={formatMessage(Messages.addressInfo_addressLine, {
          lineNumber: 2,
        })}
        {...getCommonFields('addressLine2')}
        cssClasses="formatSwitcher-unstructured-input"
      />

      <TextInput
        label={formatMessage(Messages.addressInfo_addressLine, {
          lineNumber: 3,
        })}
        {...getCommonFields('addressLine3')}
        cssClasses="formatSwitcher-unstructured-input"
      />

      <AddressCountrySelector addressState={addressState} countryList={countryList} setAddressState={setAddressState} />
      <PostalFields
        key={addressState.address.postalCode}
        getCommonFields={getCommonFields}
        setAddressState={setAddressState}
        addressState={addressState}
      />
    </>
  );
};

export default memo(UnstructuredAddress);
